import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import DataContext from "../../../../../../../../../context/DataContext";
import axios from "../../../../../../../../api/axios";
import LoadingIndicator from "../../../../../../../../global/LoadingIndicator";

import CapacityInputField from "./components/CapacityInputField";

const Capacities = ({ userId }) => {
  const { userRoles } = useContext(DataContext);
  const [userCapacity, setUserCapacity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [capacityTrigger, setCapacityTrigger] = useState(false);
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/api/user_capacity/?user=${userId}`, {
      })
      .then((response) => {
        const data = response.data;
        setUserCapacity(data);
        setLoading(false);
        return response;
      })
      .catch((err) => {
        return err;
      });
  }, [userId, params.id, capacityTrigger]);

  return (
    <div className="m-6 flex flex-col">
      <h1 className="pb-1 text-xl">Capacities</h1>
      <div className="w-full">
        {loading ? (
          <LoadingIndicator isLoading={loading} />
        ) : (
          <div
            style={{
              display: "grid",
              columnGap: 3,
              rowGap: 1,
              gridTemplateColumns: "repeat(3, 1fr)",
            }}
          >
            {userCapacity.map((userCapacityItem, index) => (
              <CapacityInputField
                key={"capacityField_" + index}
                userId={userId}
                trigger={capacityTrigger}
                setTrigger={setCapacityTrigger}
                userCapacity={userCapacityItem}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Capacities;
